module.exports = __webpack_public_path__ + "static/media/logo.4478ce80.png";